import { SelectedAddon } from 'types/SelectedItem';
import { Ticket, TicketAddon } from 'types/TicketsState';
import { IndividualTicketType } from './tickets';

/*
  Basically this function:
  1. Iterates over the displayed tickets
  2. For each ticket, it takes its addons data
  3. Iterates over the addons data
  4. If the addon is selected, it adds the quantity to the result
  5. If the addon is not selected, it adds 0 to the result
  6. Returns the result
*/
export const formatAddonsForAPI = (
  addons: SelectedAddon[],
  cartTickets: IndividualTicketType[],
  ticketsData: Ticket[],
) => {
  const result: any = {};

  const cartAddons = [...addons];

  for (let i = 0; i < cartTickets.length; i++) {
    const idOrderItem = cartTickets[i].idOrderItem;

    if (!result[idOrderItem]) {
      result[idOrderItem] = [];
    }

    const ticketAddonsData = ticketsData
      .find(ticket => ticket.id === cartTickets[i].ticketId)
      ?.ticketaddons.filter(addon => !addon.is_bundled) as TicketAddon[];

    const elementToBePushed = {};

    for (let j = 0; j < ticketAddonsData?.length; j++) {
      const addonIsSelected = cartAddons.findIndex(
        addon =>
          addon.addonId === ticketAddonsData[j].id &&
          addon.ticketId === cartTickets[i].ticketId &&
          addon.ticketIndex === i,
      );
      if (addonIsSelected >= 0) {
        elementToBePushed[ticketAddonsData[j].id] =
          cartAddons[addonIsSelected].quantity;
      } else {
        elementToBePushed[ticketAddonsData[j].id] = 0;
      }
    }

    result[idOrderItem].push(elementToBePushed);
  }

  return result;
};

export const formatTopUpsForAPI = topUps => {
  const result: any = {};

  for (let key in topUps) {
    const idOrderItem = key.split('-')[2];
    if (!result[idOrderItem]) {
      result[idOrderItem] = [];
    }
    result[idOrderItem].push(topUps[key]);
  }

  return result;
};
